import { render, staticRenderFns } from "./FormRRPlagas.vue?vue&type=template&id=6338bd9a&scoped=true"
import script from "./FormRRPlagas.vue?vue&type=script&lang=js"
export * from "./FormRRPlagas.vue?vue&type=script&lang=js"
import style0 from "./FormRRPlagas.vue?vue&type=style&index=0&id=6338bd9a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6338bd9a",
  null
  
)

export default component.exports